"use strict";

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var odc_text_1 = __importDefault(require("@tencent/odc-text"));
var StepsData = function StepsData(props, ref) {
  var _a;
  var label = props.label,
    icon = props.icon,
    active = props.active,
    direction = props.direction,
    desc = props.desc,
    labelProps = props.labelProps,
    descProps = props.descProps,
    infoClassName = props.infoClassName,
    status = props.status,
    lineStyle = props.lineStyle;
  var labelColor;
  if (status === 'doing') {
    labelColor = 'link';
  }
  if (status === 'error') {
    labelColor = 'danger';
  }
  return direction === 'horizontal' ? react_1["default"].createElement("div", {
    className: (0, classnames_1["default"])('flex items-center odc-steps-single', {
      active: active
    }, "is-".concat(status)),
    ref: ref
  }, react_1["default"].createElement("span", {
    className: (0, classnames_1["default"])('odc-steps-info inline-flex items-center', infoClassName)
  }, icon, react_1["default"].createElement(odc_text_1["default"], __assign({
    type: labelColor || 'comment',
    size: "normal",
    label: label
  }, labelProps)), react_1["default"].createElement(odc_text_1["default"], __assign({
    label: desc,
    type: "comment",
    size: "small"
  }, descProps))), react_1["default"].createElement("i", {
    className: "odc-steps-line"
  })) : react_1["default"].createElement("div", {
    className: (0, classnames_1["default"])('flex odc-steps-single', {
      active: active
    }, "is-".concat(status)),
    ref: ref,
    style: (_a = {}, _a['--steps-line-style'] = lineStyle, _a)
  }, react_1["default"].createElement("div", {
    className: "flex flex-column items-center"
  }, icon, react_1["default"].createElement("i", {
    className: (0, classnames_1["default"])('odc-steps-line', {
      'odc-steps-border': lineStyle
    })
  })), react_1["default"].createElement("div", {
    className: (0, classnames_1["default"])('odc-steps-info flex flex-column', infoClassName)
  }, react_1["default"].createElement(odc_text_1["default"], __assign({
    type: labelColor,
    className: active ? 'font-medium' : undefined,
    label: label
  }, labelProps)), react_1["default"].createElement(odc_text_1["default"], __assign({
    label: desc,
    type: "comment",
    size: "small"
  }, descProps))));
};
exports["default"] = (0, react_1.memo)((0, react_1.forwardRef)(StepsData));